import './App.css';
import { useState, useEffect } from 'react';
import SignIn from './components/SignIn';
import * as jose from 'jose'
import axios from 'axios'
import  { SERVER_URL } from './config'
import Wishlist from './containers/Wishlist';

function App() {
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [, setUser] = useState(null);
  const [token, setToken] = useState(JSON.parse(localStorage.getItem("token")));

// SIGNIN
useEffect(() => {
  const verify_token = async () => {
    try {
      if (!token) {
        setUserLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = token;
        const response = await axios.post(`${SERVER_URL}/users/verify_token`);
        return response.data.ok ? login(token) : logout();
      }
    } catch (error) {
      console.log(error);
    }
  };
  verify_token();
}, [token]);

const login = (token) => {
  let decodedToken = jose.decodeJwt(token);
  // composing a user object based on what data we included in our token (login controller - jwt.sign() first argument)
  let user = {
    email: decodedToken.userEmail,
  };
  localStorage.setItem("token", JSON.stringify(token));
  localStorage.setItem("user", JSON.stringify(user));
  setUserLoggedIn(true);
  // setCompanyID(decodedToken.companyID);
  setToken(token);

};


const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  setUserLoggedIn(false);
};
// END SINGIN
  return (
    <div className="App">
      {userLoggedIn ? <Wishlist token={token}/> : <SignIn setUserLoggedIn={setUserLoggedIn} setUser={setUser} setToken={setToken}/>}
    </div>
  );
}

export default App;
